import { useCallback, useRef, useState } from "react"
import { message } from "antd"
import { downloadByBlob } from "~/common/media/download"

// 下载防重入 + loading + 失败提示；返回是否下载成功，便于调用方继续上报下载次数
export const useDownload = () => {
  const pending = useRef(false)
  const [downloading, setDownloading] = useState(false)

  const download = useCallback(
    async (
      url: string,
      filename: string,
      errorMessage = "下载失败，请重试",
    ) => {
      if (!url || pending.current) return false

      pending.current = true
      setDownloading(true)
      try {
        await downloadByBlob(url, filename)
        return true
      } catch {
        void message.error(errorMessage)
        return false
      } finally {
        pending.current = false
        setDownloading(false)
      }
    },
    [],
  )

  return { download, downloading }
}
